/**
 * [isSupported description]
 * null: pending status(checking whether support native-api)
 * false: unsupport native-api
 * true: support native-api
 */
var readyPromise = null;
var isSupported = null;
var retryCounter = 0;
var invokeId = 0;

// store for native -> js
var nativeToJsStore = {};
// store for js -> native
var jsToNativeQueue = [];

// default js actions for native -> js
var jsActions = {
  back: null,
  headerRightBtnClick: null,
  resume: null
};

// invoke only when native api is ready
// js -> native
var sendToNative = function(msg) {
  // force the native API call async
  setTimeout(function() {
    window.NativeAPI.sendToNative(msg);
  }, 0);
};

var handleNative = function(method, id) {
  var hasAction = !!jsActions[method];
  var msg = JSON.stringify({
    result: {
      preventDefault: hasAction
    },
    id: id
  });

  sendToNative(msg);
  if (hasAction) {
    jsActions[method]();
  }
};

// native -> js
var sendToJavaScript = function(msg) {
  var nativeMsg = JSON.parse(msg) || {};
  var id = nativeMsg.id;
  // call from native
  if (nativeMsg.method) {
    handleNative(nativeMsg.method, id);
  } else if (id in nativeToJsStore) {
    if (nativeMsg.result) {
      nativeToJsStore[id].resolve(nativeMsg.result);
    } else if (nativeMsg.error) {
      nativeToJsStore[id].reject(nativeMsg.error);
    }
    delete nativeToJsStore[id];
  } else {
    console.log('Unexpected call from native: ', msg);
  }
};

// keep the msg before NativeAPI ready
var pushMsgToQueue = function(msg) {
  jsToNativeQueue.push(msg);
};

var invokeMsgFromQueue = function() {
  jsToNativeQueue.forEach(function(msg) {
    sendToNative(msg);
  });
};

var invokeNative = function(method, params={}) {
  var id = ++invokeId;

  if(params && !params.hlo_module){
    params.hlo_module = 'gtgj'
  }

  var msg = JSON.stringify({
    jsonrpn: '2.0',
    method: method,
    params: params,
    id: '' + id
  });

  return new Promise(function (resolve, reject) {
    if (isSupported === false) {
      // unsupport native-api, reject the promise
      reject(new Error('[nativeApi:' + method + '.' + id + ']Native Api is not supported!'));
    } else {
      nativeToJsStore[id] = {
        method: method,
        resolve: resolve,
        reject: reject
      };
      if (isSupported === null) {
        // pending status, push msg to queue
        pushMsgToQueue(msg);
      } else if (isSupported === true) {
        // support native-api
        sendToNative(msg);
      }
      // do not handle resolve or reject.
      // when native invoke sendToJavaScript, then resolve or reject the promise.
    }
  });
};

var ready = function() {
  return readyPromise;
};

readyPromise = new Promise(function(resolve, reject) {
  var loopCheck = setInterval(function() {
    if (!window.NativeAPI && ++retryCounter <= 5) {
      isSupported = null;
      return;
    } else if (window.NativeAPI) {
      window.NativeAPI.sendToJavaScript = sendToJavaScript;
      console.log('Native API ready');

      if (jsToNativeQueue.length) {
        invokeMsgFromQueue();
      }

      isSupported = true;
      clearInterval(loopCheck);
      resolve();
    } else {
      // reject all Promise in nativeToJsStore
      for (var id in nativeToJsStore) {
        var method = nativeToJsStore[id].method;
        nativeToJsStore[id].reject(new Error('[nativeApi:' + method + '.' + id + ']Native Api is not supported!'));
      }
      // clear nativeToJsStore
      nativeToJsStore = {};

      isSupported = false;
      clearInterval(loopCheck);
      reject({
        error: {
          msg: '此操作需要在高铁管家客户端内进行',
          code: 'NATIVE_API_NOT_FOUND'
        }
      });
      console.log('Failed to find Native API support!');
    }
  }, 500);
});

/**
 * Check if a method is supported
 * @param  {string} method method name
 * @return {promise} resolved with true/false
 */
var isMethodSupported = function isMethodSupported(method) {
  return invokeNative('isSupported', {
    method: method
  }).then(function(result) {
    return result.value == '1';
  }, function() {
    console.error('Failed to check method!');
    return false;
  });
};

export default {
  ready: ready,
  isMethodSupported: isMethodSupported,
  invoke: invokeNative,
  actions: jsActions
};



// WEBPACK FOOTER //
// ./src/utils/native-api.js